module.exports = __webpack_public_path__ + "img/gb13871-92_45x62x8.prt.85277ba5.jpg";